import PuestosTrabajo from './puestos-trabajo.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

// El acceso real lo garantiza el backend (403 a quien no sea ADMIN/DIRECTOR, decisión I3 de
// la #47) y la entrada de menú bajo Ajustes, que es el control de acceso de las rutas: el
// listado de roles de aquí solo actúa como respaldo cuando todavía no hay menú cargado.
const routes = [
    {
        path: '/puestostrabajo/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('puestostrabajo', ['ADMIN', 'DIRECTOR'], PuestosTrabajo),
        keepAlive: true
    }
];
export default routes;
